module.exports = __webpack_public_path__ + "media/images/flags/4x3/tuv-1836b623c49321f66716d4321d3712b3.svg";